"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuFooter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MenuFooter = function MenuFooter(_ref) {
  var opened = _ref.opened,
      handleOpenClose = _ref.handleOpenClose,
      children = _ref.children,
      className = _ref.className,
      background = _ref.background,
      otherProps = _objectWithoutProperties(_ref, ["opened", "handleOpenClose", "children", "className", "background"]);

  return /*#__PURE__*/_react.default.createElement(StyledMenuFooter, _extends({
    background: background,
    className: className
  }, otherProps), !background ? /*#__PURE__*/_react.default.createElement(Divider, null) : '', children);
};

exports.MenuFooter = MenuFooter;

var StyledMenuFooter = _styledComponents.default.div.withConfig({
  displayName: "StyledMenuFooter"
})(["flex:0 0 auto;padding:2rem;background-color:", ";border-top:", ";"], function (_ref2) {
  var background = _ref2.background;
  return background ? 'white' : '#fbfbfb';
}, function (_ref3) {
  var background = _ref3.background;
  return background ? '1px solid #e4e4e4' : '';
});

var Divider = _styledComponents.default.div.withConfig({
  displayName: "Divider"
})(["width:100%;height:1px;background-color:#e4e4e4;margin-bottom:2rem;"]);

MenuFooter.propTypes = {
  opened: _propTypes.bool,
  handleOpenClose: _propTypes.func,
  children: _propTypes.node.isRequired,
  className: _propTypes.string,
  background: _propTypes.bool,
  otherProps: _propTypes.object
};